import React, { useState, useEffect } from 'react'
export const ReportPopup = (props) => {

    const { visible } = props;

    const [reportType, setSetReportType] = useState(false);
    const [reportReason, setReportReason] = useState('');

    const handleChangeType = async (event) => {
        const { name, value } = event.target;
        setSetReportType(value)
        setReportReason('');
    }

    const handleChangeReason = async (event) => {
        const { name, value } = event.target;
        setReportReason(value)
    }

    if (!visible) { return (<></>) }
    return (

        <div className="popupReport" onClick={(e) => props.handleClickOutSite(e)}>
            <div className="cardPopup" >
                <h3>Lý do báo cáo vi phạm?</h3>
                <ul >
                    <li><input type="radio" name="reason" value="0" id="spam" onClick={(e) => handleChangeType(e)} /><label htmlFor="spam">Spam</label></li>
                    <li><input type="radio" name="reason" value="1" id="koLienQuan" onClick={(e) => handleChangeType(e)} /><label htmlFor="koLienQuan">Bình luận không liên quan</label></li>
                    <li><input type="radio" name="reason" value="2" id="chuaLink" onClick={(e) => handleChangeType(e)} /><label htmlFor="chuaLink">Bình luận chứa link, quảng cáo tới các trang web khác</label></li>
                    <li><input type="radio" name="reason" value="3" id="noiDungThoTuc" onClick={(e) => handleChangeType(e)} /><label htmlFor="noiDungThoTuc">Bình luận chứa nội dung thô tục, kích động bạo lực</label></li>
                    <li><input type="radio" name="reason" value="4" id="khac" onClick={(e) => handleChangeType(e)} /><label htmlFor="khac">Khác</label></li>
                </ul>
                {reportType == 4 ? (
                    <textarea className="reasonReport" value={reportReason} onChange={(e) => handleChangeReason(e)}></textarea>
                ) : (<></>)}
                <div className="footerPopup">
                    <a className="frameBtn btnCancel" onClick={() => props.onCancel()}>Hủy</a>
                    <a className="frameBtn btnSubmit" onClick={() => props.onFinish({ type: reportType, reason: reportReason })}>Gửi yêu cầu</a>
                </div>
            </div>
        </div>
    );
}